import { FALLBACK_ORIGINS, parseOriginConfig } from '@/utils/userOrigins';

export default function useOrigins() {
  const config = useRuntimeConfig();
  const parsed = parseOriginConfig(config.public?.userOrigins);
  const origins = parsed.origins ?? FALLBACK_ORIGINS;

  return {
    origins,
    defaultOrigin: origins[0].key,
    hasConfiguredOrigins: parsed.origins !== null,
  };
}
